import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {AchievementModel} from "@intelingu/core/interfaces/models/AchievementModel";
import {UserStore} from "@intelingu/core/stores/UserStore";
import {lazyInject} from "@intelingu/core/IoC/container";

interface AchievementIconProps {
    item: AchievementModel;
}

@observer export class AchievementIcon extends Component<AchievementIconProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    get prefix() {
        const { item } = this.props;

        if (item.remaining > 1) {
            return <>Lerne <span style={{ color: '#5d83bc' }}>noch {item.remaining}</span> weitere Tage </>;
        }

        return <>Lerne <span style={{ color: '#5d83bc' }}>noch {item.remaining}</span> weiteren Tag </>;
    }

    render() {
        const { item } = this.props;

        return <div className={'item col-12 col-lg-3'} key={item.id}>
            <h2>{ item.name }</h2>

            <div className={`achievement-image-wrapper ${item.unlocked ? 'unlocked' : 'locked'}`}>
                <img src={item.unlocked ? item.image : item.image_inactive} alt={item.name} />
            </div>

            <p>
                { item.unlocked ? (
                    <span style={{ color: '#5d83bc' }}>{ item.description }</span>
                ) : (
                    <>
                    { this.prefix }{ item.description_inactive }
                    </>
                ) }
            </p>
        </div>
    }

}
